
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","data-name":"Rectangle 1276","fill":"none"}}),_c('path',{attrs:{"d":"M15.646 20.707l1.414-1.414L9.768 12l7.293-7.293-1.415-1.414L6.939 12z","data-name":"Path 1259"}})])
          )
        }
      }
    